<template>
	<div class="loadViewWrap">
		<div class="loadViewRow i2-50">
			<!--Load general info-->
			<card-slot
					title="Load general info"
					icon="doc-config"
			>
				<div class="line">
					<div class="main">
						<item-info-row
								:is-item-icon="false"
								text="Load:"
								:value="load.load_id"
								margin="0"
								is-value-first-icon
								value-first-icon="number"
								value-first-icon-width="12"
								value-first-icon-height="12"
						></item-info-row>
						<item-info-row
								:is-item-icon="false"
								text="Load type:"
								:value="load.load_type"
								margin="0"
						></item-info-row>
						<item-info-row
								:is-item-icon="false"
								text="Broker load:"
								:value="load.broker_number"
								margin="0"
						></item-info-row>
						<item-info-row
								:is-item-icon="false"
								text="Broker:"
								:value="load.broker_name"
								margin="0"
						></item-info-row>
						<item-info-row
								:is-item-icon="false"
								text="Brocker MC#:"
								:value="load.mc"
								margin="0"
						></item-info-row>
						<item-info-row
								:is-item-icon="false"
								text="Rate:"
								:value="load.rate"
								margin="0"
								is-value-first-icon
								value-first-icon="icon_dollars"
								value-first-icon-width="8"
								value-first-icon-height="16"
						></item-info-row>
					</div>
				</div>
			</card-slot>

			<!--Dimensions-->
			<card-slot
					title="Dimensions"
					icon="ruler-pencil"
			>
				<div class="line">
					<div class="main">
						<item-info-row
								:is-item-icon="false"
								text="Width:"
								:value="load.dimonsions.width_from"
								margin="0"
						></item-info-row>

						<item-info-row
								:is-item-icon="false"
								text="Length:"
								:value="load.dimonsions.length_from"
								margin="0"
						></item-info-row>

						<item-info-row
								:is-item-icon="false"
								text="Height:"
								:value="load.dimonsions.height_from"
								margin="0"
						></item-info-row>

						<item-info-row
								:is-item-icon="false"
								text="Quantity:"
								:value="load.quantity"
								margin="0"
						></item-info-row>

						<item-info-row
								:is-item-icon="false"
								text="Weight:"
								:value="load.weight"
								margin="0"
						></item-info-row>

						<item-info-row
								:is-item-icon="false"
								text="Special instructions:"
								:value="load.special_instructions"
								margin="0"
						></item-info-row>
					</div>
				</div>
			</card-slot>
		</div>

<!--		Mileage Summary-->
<!--		Service info-->
		<div class="loadViewRow i2-50">
			<!--Mileage Summary-->
			<card-slot
					title="Mileage Summary"
					icon="route"
			>
				<div class="line">
					<div class="main">
						<item-info-row
								:is-item-icon="false"
								text="Mileage:"
								:value="load.mileage_total"
								margin="0"
								is-value-icon
								value-icon="icon_miles"
						></item-info-row>
						<item-info-row
								:is-item-icon="false"
								text="Mileage Loaded:"
								:value="load.pick_up_mileage"
								margin="0"
								is-value-icon
								value-icon="icon_miles"
						></item-info-row>
						<item-info-row
								:is-item-icon="false"
								text="Mileage Empty:"
								:value="load.pick_up_empty"
								margin="0"
								is-value-icon
								value-icon="icon_miles"
						></item-info-row>
					</div>
				</div>
			</card-slot>

			<!--Service info-->
			<card-slot
					title="Service info"
					icon="icon-ListDuties"
			>
				<div class="line">
					<div class="main">
						<item-info-row
								:is-item-icon="false"
								text="TONU"
								:value="booleanToOnOff(load.tonu)"
								margin="0"
						></item-info-row>

						<item-info-row
								:is-item-icon="false"
								text="Tarp"
								:value="booleanToOnOff(load.tarp)"
								margin="0"
						></item-info-row>

						<item-info-row
								v-if="load.customer_billing"
								:is-item-icon="false"
								text="Billing"
								:value="booleanToOnOff(load.billing_switch)"
								margin="0"
						></item-info-row>
						<item-info-row
								:is-item-icon="false"
								text="Billing service:"
								:value="billingService()"
								margin="0"
						></item-info-row>
					</div>
				</div>
			</card-slot>
		</div>

		<div class="loadViewRow i2-50">
			<!--Pickup information-->
			<card-slot
					title="Pickup information"
					icon="pickup"
					icon-width="28px"
					icon-height="28px"
			>
				<div class="loadStopWrap">
					<load-stop
							v-for="(item, index) in load.pickup"
							:key="item.id != null ? item.id : index"
							:index="index"
							:item="item"
							:length="load.pickup.length"
					/>
				</div>

			</card-slot>

			<!--		Delivery information-->
			<card-slot
					title="Delivery information"
					icon="delivery"
					icon-width="28px"
					icon-height="28px"
			>
				<div class="loadStopWrap">
					<load-stop
							v-for="(item, index) in load.delivery"
							:key="item.id != null ? item.id : index"
							:index="index"
							:item="item"
							:length="load.delivery.length"
					/>
				</div>

			</card-slot>
		</div>

<!--		Payments-->
		<card-slot
				v-if="isLogin.customers"
				title="Payments"
				icon="accounting"
				@updateEvent="onPayment"
		>
			<payments-view
					:load="load"
					@updateEditItem="onEditItem"
			></payments-view>
		</card-slot>
<!--		Payments-->
		<card-slot
				v-else
				title="Payments"
				icon="accounting"
				is-add-item
				@updateEvent="onPayment"
		>
			<payments-view
					:load="load"
					@updateEditItem="onEditItem"
			></payments-view>
		</card-slot>

<!--		Notes-->
		<card-slot
				v-if="hasNotes"
				title="Notes"
				icon="comment"
		>
			<notes-view
					:load="load"
			></notes-view>
		</card-slot>

<!--		Files-->
		<card-slot
				title="Files"
				icon="safe"
		>
			<files-view
					:load="load"
					:typeBilling="load.billing.type"
					@updateClickButton="onClickButtonFilesView"
					@updateNewItem="setNewItem"
			></files-view>

		</card-slot>
	</div>
</template>

<script>
import CardSlot from "@/shared/CardSlot/CardSlot.vue";
import ItemInfoRow from "@/shared/ItemInfoRow/ItemInfoRow.vue";
import LoadStop from "@/components/Dispatch/Trips/DialogTripView/LoadStop.vue";
import PaymentsView from "@/components/Dispatch/Trips/DialogTripView/PaymentsView.vue";
import NotesView from "@/components/Dispatch/Trips/DialogTripView/NotesView.vue";
import FilesView from "@/components/Dispatch/Trips/DialogTripView/FilesView.vue";
import { mapGetters } from "vuex";

export default {
	name: "LoadView",
	components: { FilesView, NotesView, PaymentsView, LoadStop, ItemInfoRow, CardSlot },
	computed: {
		...mapGetters([ 'isLogin' ]),
		hasNotes() {
			return this.load && this.load.notes && this.load.notes.length > 0;
		}
	},
	props: {
		load: Object,
	},

	data: () => ({
		isPaymentsDrawer: false,
		activeItem: null,
		activeLoadIndex: null,
	}),
	methods: {
		booleanToOnOff(value) {
			return value ? 'ON' : 'OFF';
		},
		billingService() {
			return this.load.customer_billing ? 'Active' : 'Not active';
		},
		onClickButtonFilesView(args) {
			this.$emit('updateClickButtonFilesView', args);
		},
		setNewItem(args) {
			this.$emit('updateNewItem', args);
		},
		onPayment() {
			this.isPaymentsDrawer = true;
			this.$emit('updatePaymentAddItem');
		},
		onEditItem({ key, item, nameComponent, itemIndex }) {
			this.$emit('updateEditItem', { key, item, nameComponent, itemIndex, load: this.load });
		},

	}

};
</script>

<style scoped lang="scss">
.loadViewWrap {
	display: grid;
	grid-gap: 10px;
	grid-template-columns: 1fr;
	.head {

	}
	.loadViewRow {
		display: grid;
		grid-gap: 10px;
		&.i2-50 {
			grid-template-columns: repeat(2, 1fr);
			@media screen and (max-width: 1300px) {
				grid-template-columns: 1fr;
			}
		}
	}

	.loadStopWrap {
		display: flex;
		flex-direction: column;
		gap: 10px;

	}
	.line {
		.main {
			display: flex;
			flex-direction: column;
			gap: 6px;
		}
	}
}

</style>
